import apiClient from "../../utils/interceptor";
import { ApiResponse, GetCountsData } from "./interface";
import { API_URLS } from "../../constants";

// Helper function to get auth token from localStorage
const getAuthToken = (): string | null => {
    return localStorage.getItem("auth_token");
};

// Function to get total users & companies count
export const getCounts = async (): Promise<ApiResponse<GetCountsData>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.get<ApiResponse<GetCountsData>>(
            API_URLS.HOME.GET_COUNTS,
            {
                headers: {
                    Authorization: token ? `Bearer ${token}` : "",
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching counts:", error);
        throw error;
    }
};
